import { useI18n } from 'petite-vue-i18n'
import { defineStore } from 'pinia'
import { computed, ref } from 'vue'
import { getInstallationComponents } from '../api/components'

export const useComponentStore = defineStore('component', () => {
  const { t } = useI18n()

  const components = ref(null)
  const componentsRevision = ref(0)
  const loadingCount = ref(0)

  const isLoadingComponents = computed(() => loadingCount.value > 0)
  const componentTree = computed(() => {
    function createItem(component) {
      const children = []
      for (const child of components.value) {
        if (child.parent_id === component.id) {
          children.push(createItem(child))
        }
      }

      return Object.assign({}, component, { children })
    }

    const roots = components.value.filter(c => c.parent_id === null)
    return roots.map(r => createItem(r))
  })

  function getLabel(subgroupCode) {
    const key = `component.${subgroupCode}`
    const label = t(key)
    return label === key ? subgroupCode : label
  }

  async function loadComponents(installationId) {
    ++loadingCount.value
    try {
      const revision = ++componentsRevision.value
      const data = await getInstallationComponents(installationId)
      if (revision !== componentsRevision.value) {
        return // data is stale, ignore
      }

      components.value = data
    } finally {
      --loadingCount.value
    }
  }

  return { getLabel, loadComponents, isLoadingComponents, componentTree }
})
